import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {QueryResult, TrainingHistory} from '@app/shared';

@Injectable()
export class TrainingHistoryDataService {

  constructor (private http: HttpClient) { }

  searchTrainingHistory(userId: number): Observable<QueryResult> {
    const url = `/hr/training-histories/search?user.id=${userId}`;
    return this.http.get<QueryResult>(url);
  }

  updateTrainingHistory(trainingHistories: TrainingHistory[]): Observable<QueryResult> {
    return this.http.put<QueryResult>(`/hr/users/${trainingHistories[0].userId}/training-histories`, trainingHistories);
  }

}
